import { createReducer, on } from '@ngrx/store';
import { SuggestedUserApiActions } from './suggested-user.actions';
import { initialState, adapter } from './suggested-user.state';

export const suggestedUsersReducer = createReducer(
  initialState,
  on(SuggestedUserApiActions.suggestedUsersLoaded, (state, { suggestedUsers }) => adapter.setAll(suggestedUsers, state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectSuggestedUserIds = selectIds;

export const selectSuggestUserEntities = selectEntities;

export const selectAllSuggestedUsers = selectAll;
